import {Button, Card} from "react-bootstrap";
import {useContext, useEffect} from "react";
import {BackendContext} from "../../context/Backend";
import {useLocation, useNavigate} from "react-router";
import {ExclamationCircle} from "react-bootstrap-icons";

export const Error = (props) => {

    const backend = useContext(BackendContext);
    const navigate = useNavigate();
    const location = useLocation();

    const error = location.state?.error;

    useEffect(()=>{
        //backend.api.logout((resp)=>{},(error)=>{})
    })

    function handleLoginClick() {
        navigate("/login",{replace:true})
    }

    return(
        <Card>
            <Card.Header as="h1" className={"text-danger"}><ExclamationCircle size={"3rem"} className={"me-2 align-bottom"}/>Error</Card.Header>
            <Card.Body className={"bg-dark-subtle"}>
                <Card.Title className={"text-danger"}>{error?.status} - {error?.timestamp}</Card.Title>
                <Card.Text>
                    Should this continue to occur, please contact support. You have been logged out for security reasons.
                </Card.Text>
                <Button variant="primary" onClick={handleLoginClick}>Login</Button>
            </Card.Body>
        </Card>
    )
};